import React, { useEffect, useState } from 'react';
import { FiX, FiMessageSquare } from 'react-icons/fi';

const Feedback = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    name: '',
    email: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    let timer;
    if (isModalVisible) {
      timer = setTimeout(() => {
        setIsModalVisible(false);
      }, 10000);
    }
    return () => clearTimeout(timer);
  }, [isModalVisible]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = validateForm(formData);
    if (Object.keys(errors).length === 0) {
      // Submit the form data
      console.log('Form data submitted:', formData);
      setFormData({
        title: '',
        description: '',
        name: '',
        email: '',
      });
      setFormErrors({});
      setIsModalVisible(true);
      // Here you would typically send the data to a server or handle it as needed
    } else {
      setFormErrors(errors);
    }
  };

  const validateForm = (data) => {
    let errors = {};
    if (!data.title) errors.title = 'Title is required';
    if (!data.description) errors.description = 'Description is required';
    if (!data.name) errors.name = 'Name is required';
    if (!data.email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = 'Email is invalid';
    }
    return errors;
  };

  const NotificationPopup = () => (
    <div
      className="fixed bottom-4 right-4 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-lg flex items-center space-x-2 cursor-pointer"
      onClick={closeModal}
    >
      <p className="text-black dark:text-white text-lg">
        Feedback successfully submitted!
      </p>
      <FiX className="text-black dark:text-white text-lg" />
    </div>
  );

  // Function to close the modal
  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="p-6 md:p-10 max-w-4xl w-full mx-auto text-sm">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary text-primary-foreground">
          <FiMessageSquare className="w-5 h-5" />
        </div>
        <div>
          <h1 className="text-2xl font-display font-bold text-foreground">
            Feedback
          </h1>
          <p className="text-sm text-muted-foreground">
            Let us know how we can improve
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-5 rounded-lg border border-border bg-card p-6">
        <div className="space-y-2">
          <label className="block text-gray-700 dark:text-gray-200 font-bold mb-2">
            Title <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 transition-colors shadow appearance-none text-gray-700 leading-tight"
            placeholder="Title"
          />
          {formErrors.title && (
            <p className="text-red-500 text-sm italic">{formErrors.title}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-gray-700 dark:text-gray-200 font-bold mb-2">
            Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 transition-colors shadow appearance-none text-gray-700 leading-tight"
            placeholder="Name"
          />
          {formErrors.name && (
            <p className="text-red-500 text-sm italic">{formErrors.name}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-gray-700 dark:text-gray-200 font-bold mb-2">
            Contact Email <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 transition-colors shadow appearance-none text-gray-700 leading-tight"
            placeholder="Email Address"
          />
          {formErrors.email && (
            <p className="text-red-500 text-sm italic">{formErrors.email}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-gray-700 dark:text-gray-200 font-bold mb-2">
            Description <span className="text-red-500">*</span>
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 transition-colors shadow appearance-none text-gray-700 leading-tight"
            placeholder="Describe the issue"
            rows="4" // Adjust the number of rows as needed
          />
          {formErrors.description && (
            <p className="text-red-500 text-sm italic">
              {formErrors.description}
            </p>
          )}
        </div>
        {/* Repeat similar structure for Description, Name, and Email fields */}

        <button
          type="submit"
          className="bg-blue-500 hover:bg-blue-700 text-white text-sm w-full font-bold py-2 px-4 rounded-md focus:outline-none focus:shadow-outline"
        >
          Submit
        </button>
      </form>

      {isModalVisible && <NotificationPopup />}
    </div>
  );
};

export default Feedback;
